import { createGlyphComponent } from "@via-ds/icons";

export const Ignored = createGlyphComponent(
  "Ignored",
  "0 0 16 16",
  <path
    clipRule="evenodd"
    d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"
    fill="currentColor"
    fillRule="evenodd"
  />,
);
